import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const TbNotEqualsIcon = () => {
    return (
        <SvgIcon>
            <polygon points="19.99 9.79 19.99 8.32 16.72 8.32 19.6 5.44 18.56 4.4 14.64 8.32 4.01 8.32 4.01 9.79 13.17 9.79 8.75 14.21 4.01 14.21 4.01 15.68 7.28 15.68 4.4 18.56 5.44 19.6 9.36 15.68 19.99 15.68 19.99 14.21 10.83 14.21 15.25 9.79 19.99 9.79" />
        </SvgIcon>
    );
};
